




import { Component, Prop, Vue } from 'vue-property-decorator';
import { BButton, BIcon, BSpinner } from 'bootstrap-vue';

@Component({
    components: {
        'b-btn': BButton,
        'b-icon': BIcon,
        'b-spinner': BSpinner
    }
})
export default class SpinnerButton extends Vue {
    @Prop() permissions!: boolean;
    @Prop() type!: string;
    @Prop() variant!: string;
    @Prop() size!: string;
    @Prop() buttonClass!: string | Array<string> | object;
    @Prop() isBusy!: boolean;
    @Prop() icon!: string;
    @Prop() text!: string;

    get buttonType() {
        return this.type ?? 'button';
    }

    onClick(e: Event) {
        this.$emit('click', e);
    }
}
